import type { ID } from '@proofroom/schema';
import type { ChangeConflict, ResolvedChange } from '../api/endpoints';

export interface SendResultBannerProps {
  created: ResolvedChange[];
  conflicts: ChangeConflict[];
  /** Identifies the paragraph a conflict landed on the way the rail already identifies one: by its story. */
  paraLabel(paraId: ID): string;
  onDismiss(): void;
}

export function SendResultBanner({ created, conflicts, paraLabel, onDismiss }: SendResultBannerProps) {
  return (
    <div className="compose-box">
      <div className="label">Sent to the designer</div>
      <div className="small">
        {created.length === 0
          ? 'No paragraph differed from the draft, so nothing was sent.'
          : `${created.length} change${created.length === 1 ? '' : 's'} proposed: ${created.map((c) => c.kind).join(', ')}.`}
      </div>
      {conflicts.map((c) => (
        <div key={c.changeId} className="small muted">Also proposed by {c.authorName} on {paraLabel(c.paraId)}</div>
      ))}
      <button className="btn sm ghost" style={{ marginTop: 6 }} onClick={onDismiss}>Dismiss</button>
    </div>
  );
}
